export class BaseSheet {
  sheet_code: string
  grade: number
  curriculum_id: number
  level: string
  month: number
  name: string
  page_count: number
  
  constructor(base_sheet: any){
    this.sheet_code = base_sheet.sheet_code;
    this.grade = base_sheet.grade;
    this.curriculum_id = base_sheet.curriculum_id;
    this.level = base_sheet.level;
    this.month = base_sheet.month;
    this.name = base_sheet.name;
    this.page_count = base_sheet.page_count;
  }
}

export class Sheet {
  room_code: number
  class_code: number
  room_name: string
  class_name: string

  constructor(sheet: any){
    this.room_code = sheet.room_code;
    this.class_code = sheet.class_code;
    this.room_name = sheet.room_name;
    this.class_name = sheet.class_name;
  }
}

export class SheetActivity{
  id: number = 0
  student_id: number = 0
  page: number = 0
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  base64Image: string | null = null

  constructor(sa: any){
    this.id = sa.id;
    this.student_id = sa.student_id;
    this.page = sa.page;
  }
 }

 export class Examinee{
  id: number = 0
  student_no: number
  student_code: number
  cram_code: number
  student_name: string
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  isSelected: boolean = false

  constructor(examinee: any, sheet_activities: any[]){
    this.id = examinee.id;
    this.student_no = examinee.student_no;
    this.student_code = examinee.student_code;
    this.cram_code = examinee.cram_code;
    this.student_name = examinee.student_name;
    
    const sheetActivities = new Array<SheetActivity>();
    sheet_activities.filter((x: any) => x.student_id == this.student_no).forEach((x: any) => {
      sheetActivities.push(new SheetActivity(x));
    });
    
    this.sheetActivities = sheetActivities.sort((a: SheetActivity, b: SheetActivity) => a.page < b.page ? -1 : 1);
  }
}